"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
const prism_react_renderer_1 = __importStar(require("prism-react-renderer"));
const nightOwl_1 = __importDefault(require("prism-react-renderer/themes/nightOwl"));
const Basic = (props) => {
    return (react_1.default.createElement(prism_react_renderer_1.default, Object.assign({}, prism_react_renderer_1.defaultProps, { theme: nightOwl_1.default, code: props.code, language: "jsx" }), ({ className, style, tokens, getLineProps, getTokenProps }) => (react_1.default.createElement(style_1.Pre, { className: className, style: style }, tokens.map((line, i) => (react_1.default.createElement("div", Object.assign({}, getLineProps({ line }), { key: i }),
        react_1.default.createElement(style_1.LineNo, null, i + 1),
        line.map((token, keyg) => (react_1.default.createElement("span", Object.assign({}, getTokenProps({ token, keyg }), { key: keyg })))))))))));
};
exports.default = Basic;
